import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const maintenanceSolicitationObjectiveSchema = z.object({
  system_id: optionSchema,
  part_id: optionSchema,
  action_id: optionSchema,
})

export const maintenanceSolicitationCreateSchema = z.object({
  photos_attachments: z
    .array(
      z.object({
        id: z.string(),
        file: z.custom<string | File>(),
      }),
    )
    .optional(),
  equipment_id: optionSchema,
  kind: optionSchema,
  observations: z
    .string({ message: 'Campo obrigatório' })
    .trim()
    .min(8, { message: 'Mínimo de 8 caracteres' })
    .max(128, { message: 'Máximo de 128 caracteres' }),
  objectives: z
    .array(maintenanceSolicitationObjectiveSchema.merge(z.object({ id: z.string().optional() })))
    .refine((objectives) => objectives.length > 0, { message: 'Adicione pelo menos um objeto de manutenção' }),
})

export type MaintenanceSolicitationObjectiveValidationSchema = z.infer<typeof maintenanceSolicitationObjectiveSchema>
export type MaintenanceSolicitationValidationSchema = z.infer<typeof maintenanceSolicitationCreateSchema>
